import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { DefaultOptionType } from 'antd/lib/select';

import { Settings } from 'src/interfaces/pages/settings';
import { useAppDispatch, useAppSelector } from 'src/stores';
import { getSettingSafieAction, settingSafieAction } from 'src/stores/screens/privateScreens/settings/settings.action';
import { schemaSafie } from './schemaSafie';

const useSafie = (): Settings.useFormSystemSettings => {
  const dispatch = useAppDispatch();

  const { terminals } = useAppSelector(state => state.terminals);
  const { meInfo } = useAppSelector(state => state.auth);
  const { isLoading, dataSettingSafieTerminal } = useAppSelector(state => state.settings);

  const [terminalId, setTerminalId] = useState(meInfo?.terminalId);

  const optionsSelectTerminal: DefaultOptionType[] = terminals?.map(item => {
    return {
      label: item.name,
      value: item.id,
    };
  });

  const initialValues: Settings.InitialValuesSystemSettings = {
    key: dataSettingSafieTerminal?.key,
    terminalId,
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schemaSafie,
    onSubmit: values => {
      void changeSettingTerminal(values);
    },
  });

  const changeSettingTerminal = async (data): Promise<void> => {
    void dispatch(
      settingSafieAction({
        data: {
          terminalId: meInfo?.terminalId,
          ...data,
        },
      }),
    );
  };

  useEffect(() => {
    void dispatch(getSettingSafieAction(terminalId));
  }, [terminalId]);

  return {
    isLoading,
    optionsSelectTerminal,
    formik,
    setTerminalId,
    changeSettingTerminal,
  };
};

export default useSafie;
